import { render, staticRenderFns } from "./message-order.vue?vue&type=template&id=09724a67&scoped=true"
import script from "./message-order.vue?vue&type=script&lang=ts"
export * from "./message-order.vue?vue&type=script&lang=ts"
import style0 from "./message-order.vue?vue&type=style&index=0&id=09724a67&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09724a67",
  null
  
)

export default component.exports